import { ChangeEvent, useMemo } from 'react';

import { Callable, Optional } from '@vimeo/core/types/generic';

import {
  T_ARE_YOU_SURE_BLOCK_USER,
  T_ARE_YOU_SURE_DELETE_MESSAGE,
  T_BLOCK_USER,
  T_DELETE_MESSAGE,
} from '../../../../translations';
import { CallablePlaceholder } from '../../../../types/general';

export interface IUseModalParams {
  deleteMessageId: Optional<string>;
  handleDeleteCancel: Callable;
  handleDeleteConfirm: Callable;
  blockUserId: Optional<string>;
  handleBlockUserCancel: Callable;
  handleBlockUserConfirm: Callable;
  onCheckAskAgain: (event: ChangeEvent<HTMLInputElement>) => void;
}

export interface IModalProps {
  active: boolean;
  header: string;
  text: string;
  cancelAction: Callable;
  confirmAction: Callable;
  showAskAgainCheckBox?: boolean;
  onCheck?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function useModalProps({
  deleteMessageId,
  handleDeleteCancel,
  handleDeleteConfirm,
  blockUserId,
  handleBlockUserCancel,
  handleBlockUserConfirm,
  onCheckAskAgain,
}: IUseModalParams): IModalProps {
  return useMemo(() => {
    if (Boolean(deleteMessageId))
      return {
        active: Boolean(deleteMessageId),
        header: T_DELETE_MESSAGE,
        text: T_ARE_YOU_SURE_DELETE_MESSAGE,
        cancelAction: handleDeleteCancel,
        confirmAction: handleDeleteConfirm,
        onCheck: onCheckAskAgain,
        showAskAgainCheckBox: true,
      };

    if (Boolean(blockUserId))
      return {
        active: Boolean(blockUserId),
        header: T_BLOCK_USER,
        text: T_ARE_YOU_SURE_BLOCK_USER,
        cancelAction: handleBlockUserCancel,
        confirmAction: handleBlockUserConfirm,
      };

    return {
      active: false,
      header: '',
      text: '',
      cancelAction: CallablePlaceholder,
      confirmAction: CallablePlaceholder,
    };
  }, [
    deleteMessageId,
    handleDeleteCancel,
    handleDeleteConfirm,
    blockUserId,
    handleBlockUserCancel,
    handleBlockUserConfirm,
    onCheckAskAgain,
  ]);
}
